import { Select, MenuItem, makeStyles, createStyles, FormControl, InputLabel } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
// import React from 'react';
const useStyles = makeStyles((theme) =>
    createStyles({
        selectAdornment: {
        // marginRight: theme.spacing(3),
        },
        form: {
            margin :5
        },
        selectField:{
            width: '100%',
            '&::placeholder': {
                color: "#000"
            },
            '&:focus':{
                borderRadius: 0,
                backgroundColor: 'inherit'
            }
        },
        shrink: {
            transform: "translate(14px, -5.5px) scale(0.75)!important"
        },
        icon: {
            position: "relative",
        },
        onFocus: {
            '&:focus': {
                backgroundColor: 'none'
            }
        },
    })
);

export function SelectEndornmentNationPolitiqueNoremb(props:any) {
    const classes= useStyles();
    const {t} = useTranslation<'common'>();
    // const detailPays=(value:any)=>{

    // }
    return (
        <FormControl className={classes.form}>
            <InputLabel classes={{shrink: classes.shrink}}>{t("register.nombreAnulation")}</InputLabel>
                <Select
                labelId={props.id ?? ''}
                value={props.selectedValue}
                className={classes.selectField}
                name={props.name}
                label={t("register.nombreAnulation")}
                variant="outlined"
                onChange={e=>props.handleOnChange(e.target.name as string, e.target.value as string)}
                disabled={props.remboursable==="noremboursable" ? props.isUpdating : true }
                // startAdornment={
                // <InputAdornment className={classes.selectAdornment} position="start">
                //     {props.IconElement}
                // </InputAdornment>
                // }
            >
                 {
                    props.values.map((value:any, i:number) => {
                        return <MenuItem key={i} value={ value.name } selected={value.selected}>{value.name}</MenuItem>;
                    })
                }
            </Select>
        </FormControl>
    );
}

